import React from 'react';
import { releaseConfig } from '../config/releaseConfig';

function Logo() {
  return (
    <div className="logo-container">
      <img 
        src={releaseConfig.artist.logo} 
        alt={`${releaseConfig.artist.name} Logo`} 
        className="logo" 
      />
    </div>
  );
}

export default Logo;